/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import { config } from "config";

import Index from "views/Index.js";
import Profile from "views/examples/Profile.js";
import Maps from "views/examples/Maps.js";
import Register from "views/examples/Register.js";
import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";

import Empresas from "views/empresas";
import FormEmpresa from "views/empresas/form";
import FormMunicipio from "views/municipios/form";
import FormLote from "views/lotes/form";
import Consorcios from "views/consorcios";
import FormConsorcio from "views/consorcios/form";
import Contratos from "views/contratos";
import FormContrato from "views/contratos/Form";
import NovoAditivoPasso1 from "views/contratos/Form/Aditivos/novo/passo1";
import NovoAditivoPasso2 from "views/contratos/Form/Aditivos/novo/passo2";
import AlterarAditivo from "views/contratos/Form/Aditivos/alterar";

import Projetos from "views/projetos";
import FormProjeto from "views/projetos/form";

import Cruzamentos from "views/cruzamentos";
import FormCruzamento from "views/cruzamentos/Form";


import Login from "views/login";
import ResetarSenha from "views/login/ResetarSenha";
import Usuarios from "views/usuarios";
import FormUsuario from "views/usuarios/Form";
import Perfis from "views/perfis";
import FormPerfil from "views/perfis/form";
import Municipios from "views/municipios";
import Lotes from "views/lotes";

import OrdensServico from "views/ordensServico";
import FormOrdemServico from "views/ordensServico/Form";
import Dashboard from "views/contratos/dashboard";
import Relatorios from "views/relatorios";
import HistoricoAlteracaoContrato from "views/contratos/historico";
import Componentes from "views/componentes";
import FormComponente from "views/componentes/Form";
import IncluirOSSemaforica from "views/ordensServico/IncluirOSSemaforica";
import Veiculos from "views/veiculos";
import FormVeiculo from "views/veiculos/form";
import Equipes from "views/equipes";
import FormEquipe from "views/equipes/form";
import TiposComponente from "views/tiposComponente";
import FormTipoComponente from "views/tiposComponente/form";
import ModelosComponente from "views/modelosComponente";
import FormModeloComponente from "views/modelosComponente/form";
import TiposAnexoCruzamento from "views/tiposAnexoCruzamento";
import FormTipoAnexoCruzamento from "views/tiposAnexoCruzamento/form";
import Marcas from "views/marcas";
import FormMarca from "views/marcas/form";
import TiposProblema from "views/tiposProblema";
import FormTipoProblema from "views/tiposProblema/form";
import FormCamera from "views/cruzamentos/Form/Cameras/form";
import Mapa from "views/mapa";
import Descartes from "views/descartes";
import FormDescarte from "views/descartes/Form";


const templateRoutes = [
  {
    path: "/icons",
    name: "Icons",
    icon: "ni ni-planet text-blue",
    component: <Icons />,
    layout: "/admin",
    showMenu: true,
  },
  {
    path: "/maps",
    name: "Maps",
    icon: "ni ni-pin-3 text-orange",
    component: <Maps />,
    layout: "/admin",
    showMenu: true,
  },
  {
    path: "/user-profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/admin",
    showMenu: true,
  },
  {
    path: "/tables",
    name: "Tables",
    icon: "ni ni-bullet-list-67 text-red",
    component: <Tables />,
    showMenu: true,
    layout: "/admin",
  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: <Register />,
    layout: "/auth",
    showMenu: true,
  },
]

var routes = [
  {
    path: "/index",
    name: "Painel",
    icon: "ni ni-tv-2 text-primary",
    component: <Index />,
    layout: "/admin",
    showMenu: false,
    acoes: ['dashboard.visualizar']
  },
  {
    path: "/dashboard",
    name: "Painel",
    icon: "ni ni-tv-2 text-primary",
    component: <Dashboard />,
    layout: "/admin",
    showMenu: true,
    acoes: ['dashboard.visualizar'],
    ordemMenu: 10
  },
  {
    path: "/empresas",
    name: "Empresas",
    icon: "ni ni-tv-2 text-primary",
    component: <Empresas />,
    layout: "/admin",
    showMenu: true,
    acoes: ['empresa.gerenciar'],
    grupo: "Gestão contratual",
    ordemMenu: 53
  },
  {
    path: "/empresas/:id",
    name: "Empresas",
    icon: "ni ni-tv-2 text-primary",
    component: <FormEmpresa />,
    layout: "/admin",
    showMenu: false,
    acoes: ['empresa.gerenciar']
  },

  {
    path: "/municipios",
    name: "Municípios",
    icon: "ni ni-tv-2 text-primary",
    component: <Municipios />,
    layout: "/admin",
    showMenu: true,
    acoes: ['municipio.gerenciar'],
    grupo: "Cadastros auxiliares",
    ordemMenu: 81
  },
  {
    path: "/municipios/:id",
    name: "Municípios",
    icon: "ni ni-tv-2 text-primary",
    component: <FormMunicipio />,
    layout: "/admin",
    showMenu: false,
    acoes: ['municipio.gerenciar']
  },
  {
    path: "/lotes",
    name: "Lotes",
    icon: "ni ni-tv-2 text-primary",
    component: <Lotes />,
    layout: "/admin",
    showMenu: true,
    acoes: ['lote.gerenciar'],
    grupo: "Cadastros auxiliares",
    ordemMenu: 82
  },
  {
    path: "/lotes/:id",
    name: "Lotes",
    icon: "ni ni-tv-2 text-primary",
    component: <FormLote />,
    layout: "/admin",
    showMenu: false,
    acoes: ['lote.gerenciar']
  },

  {
    path: "/tipos-componente",
    name: "Tipos de Componentes",
    icon: "ni ni-tv-2 text-primary",
    component: <TiposComponente />,
    layout: "/admin",
    showMenu: true,
    acoes: ['tipo_componente.gerenciar'],
    ocultarContratoNormal: true,
    grupo: "Cadastros auxiliares",
    ordemMenu: 85
  },

  {
    path: "/tipos-componente/:id",
    name: "Tipos de Componentes",
    icon: "ni ni-tv-2 text-primary",
    component: <FormTipoComponente />,
    layout: "/admin",
    showMenu: false,
    acoes: ['tipo_componente.gerenciar']
  },

  {
    path: "/modelos-componente",
    name: "Modelos de Componente",
    icon: "ni ni-tv-2 text-primary",
    component: <ModelosComponente />,
    layout: "/admin",
    showMenu: true,
    acoes: ['modelo_componente.gerenciar'],
    ocultarContratoNormal: true,
    grupo: "Cadastros auxiliares",
    ordemMenu: 84
  },

  {
    path: "/modelos-componente/:id",
    name: "Modelos de Componente",
    icon: "ni ni-tv-2 text-primary",
    component: <FormModeloComponente />,
    layout: "/admin",
    showMenu: false,
    acoes: ['modelo_componente.gerenciar']
  },

  {
    path: "/tipos-anexo-cruzamento",
    name: "Tipos de Anexo do Cruzamento",
    icon: "ni ni-tv-2 text-primary",
    component: <TiposAnexoCruzamento />,
    layout: "/admin",
    showMenu: true,
    acoes: ['tipo_anexo_cruzamento.gerenciar'],
    ocultarContratoNormal: true,
    grupo: "Cadastros auxiliares",
    ordemMenu: 86
  },

  {
    path: "/tipos-anexo-cruzamento/:id",
    name: "Tipos de Anexo do Cruzamento",
    icon: "ni ni-tv-2 text-primary",
    component: <FormTipoAnexoCruzamento />,
    layout: "/admin",
    showMenu: false,
    acoes: ['tipo_anexo_cruzamento.gerenciar']
  },

  {
    path: "/marcas",
    name: "Marcas",
    icon: "ni ni-tv-2 text-primary",
    component: <Marcas />,
    layout: "/admin",
    showMenu: true,
    acoes: ['marca.gerenciar'],
    ocultarContratoNormal: true,
    grupo: "Cadastros auxiliares",
    ordemMenu: 83
  },

  {
    path: "/marcas/:id",
    name: "Marcas",
    icon: "ni ni-tv-2 text-primary",
    component: <FormMarca />,
    layout: "/admin",
    showMenu: false,
    acoes: ['marca.gerenciar']
  },

  {
    path: "/tipos-problema",
    name: "Tipos de Problema",
    icon: "ni ni-tv-2 text-primary",
    component: <TiposProblema />,
    layout: "/admin",
    showMenu: true,
    acoes: ['tipo_problema.gerenciar'],
    ocultarContratoNormal: true,
    grupo: "Cadastros auxiliares",
    ordemMenu: 87
  },

  {
    path: "/tipos-problema/:id",
    name: "Tipos de Problema",
    icon: "ni ni-tv-2 text-primary",
    component: <FormTipoProblema />,
    layout: "/admin",
    showMenu: false,
    acoes: ['tipo_problema.gerenciar']
  },


  {
    path: "/consorcios",
    name: "Consórcios",
    icon: "ni ni-tv-2 text-primary",
    component: <Consorcios />,
    layout: "/admin",
    showMenu: true,
    acoes: ['consorcio.gerenciar'],
    grupo: "Gestão contratual",
    ordemMenu: 52
  },
  {
    path: "/consorcios/:id",
    name: "Consórcios",
    icon: "ni ni-tv-2 text-primary",
    component: <FormConsorcio />,
    layout: "/admin",
    showMenu: false,
  },
  {
    path: "/contratos",
    name: "Contratos",
    icon: "ni ni-tv-2 text-primary",
    component: <Contratos />,
    layout: "/admin",
    showMenu: true,
    acoes: ['contrato.gerenciar'],
    grupo: "Gestão contratual",
    ordemMenu: 51
  },
  {
    path: "/contratos/:id",
    name: "Contratos",
    icon: "ni ni-tv-2 text-primary",
    component: <FormContrato />,
    layout: "/admin",
    showMenu: false,
    acoes: ['contrato.gerenciar']
  },
  {
    path: "/contratos/:idContrato/historico",
    name: "Histórico de Alterações do Contrato",
    icon: "ni ni-tv-2 text-primary",
    component: <HistoricoAlteracaoContrato />,
    layout: "/admin",
    showMenu: false,
    acoes: ['contrato.gerenciar']
  },
  {
    path: "/contratos/:idContrato/aditivos/novo/passo1",
    name: "Contratos",
    icon: "ni ni-tv-2 text-primary",
    component: <NovoAditivoPasso1 />,
    layout: "/admin",
    showMenu: false,
    acoes: ['aditivo.gerenciar']
  },
  {
    path: "/contratos/:idContrato/aditivos/novo/passo2",
    name: "Contratos",
    icon: "ni ni-tv-2 text-primary",
    component: <NovoAditivoPasso2 />,
    layout: "/admin",
    showMenu: false,
    acoes: ['aditivo.gerenciar']
  },
  {
    path: "/contratos/:idContrato/aditivos/:idAditivo",
    name: "Contratos",
    icon: "ni ni-tv-2 text-primary",
    component: <AlterarAditivo />,
    layout: "/admin",
    showMenu: false,
    acoes: ['aditivo.gerenciar']
  },

  {
    path: "/projetos",
    name: "Projetos",
    icon: "ni ni-tv-2 text-primary",
    component: <Projetos />,
    layout: "/admin",
    showMenu: true,
    acoes: ['projeto.visualizar'],
    grupo: "Operação",
    ordemMenu: 22
  },
  {
    path: "/projetos/:id",
    name: "Projetos",
    icon: "ni ni-tv-2 text-primary",
    component: <FormProjeto />,
    layout: "/admin",
    showMenu: false,
  },

  {
    path: "/mapa",
    name: "Mapa operacional",
    icon: "ni ni-tv-2 text-primary",
    component: <Mapa />,
    layout: "/admin",
    showMenu: true,
    acoes: ['cruzamento.visualizar'],
    ocultarContratoNormal: true,
    grupo: "Operação",
    ordemMenu: 23
  },
  {
    path: "/cruzamentos",
    name: "Cruzamentos",
    icon: "ni ni-tv-2 text-primary",
    component: <Cruzamentos />,
    layout: "/admin",
    showMenu: true,
    acoes: ['cruzamento.visualizar'],
    ocultarContratoNormal: true,
    grupo: "Parque semafórico",
    ordemMenu: 31
  },
  {
    path: "/cruzamentos/:id",
    name: "Cruzamentos",
    icon: "ni ni-tv-2 text-primary",
    component: <FormCruzamento />,
    layout: "/admin",
    showMenu: false,
    acoes: ['cruzamento.visualizar']
  },
  {
    path: "/cruzamentos/:idCruzamento/cameras/:id",
    name: "Cruzamentos - Câmeras",
    icon: "ni ni-tv-2 text-primary",
    component: <FormCamera />,
    layout: "/admin",
    showMenu: false,
    acoes: ['camera.visualizar']
  },

  {
    path: "/componentes",
    name: "Componentes",
    icon: "ni ni-tv-2 text-primary",
    component: <Componentes />,
    layout: "/admin",
    showMenu: true,
    acoes: ['componente.visualizar'],
    ocultarContratoNormal: true,
    grupo: "Parque semafórico",
    ordemMenu: 32
  },
  {
    path: "/componentes/:id",
    name: "Componentes",
    icon: "ni ni-tv-2 text-primary",
    component: <FormComponente />,
    layout: "/admin",
    showMenu: false,
    acoes: ['componente.visualizar']
  },

  {
    path: "/descartes",
    name: "Descartes",
    icon: "ni ni-tv-2 text-primary",
    component: <Descartes />,
    layout: "/admin",
    showMenu: true,
    acoes: ['descarte.visualizar'],
    ocultarContratoNormal: true,
    grupo: "Parque semafórico",
    ordemMenu: 33
  },
  {
    path: "/descartes/:id",
    name: "Descartes",
    icon: "ni ni-tv-2 text-primary",
    component: <FormDescarte />,
    layout: "/admin",
    showMenu: false,
    acoes: ['descarte.visualizar']
  },


  {
    path: "/veiculos",
    name: "Veículos",
    icon: "ni ni-tv-2 text-primary",
    component: <Veiculos />,
    layout: "/admin",
    showMenu: true,
    acoes: ['veiculo.visualizar'],
    independeContrato: true, // SDD 046
    grupo: "Recursos",
    ordemMenu: 42
  },
  {
    path: "/veiculos/:id",
    name: "Veículos",
    icon: "ni ni-tv-2 text-primary",
    component: <FormVeiculo />,
    layout: "/admin",
    showMenu: false,
    acoes: ['veiculo.visualizar']
  },
  {
    path: "/equipes",
    name: "Equipes",
    icon: "ni ni-tv-2 text-primary",
    component: <Equipes />,
    layout: "/admin",
    showMenu: true,
    acoes: ['equipe.visualizar'],
    independeContrato: true, // SDD 046
    grupo: "Recursos",
    ordemMenu: 41
  },
  {
    path: "/equipes/:id",
    name: "Equipes",
    icon: "ni ni-tv-2 text-primary",
    component: <FormEquipe />,
    layout: "/admin",
    showMenu: false,
    acoes: ['equipe.visualizar']
  },

  {
    path: "/usuarios",
    name: "Usuários",
    icon: "ni ni-tv-2 text-primary",
    component: <Usuarios />,
    layout: "/admin",
    showMenu: true,
    acoes: ['usuario.gerenciar'],
    independeContrato: true, // SDD 046
    grupo: "Usuários e acessos",
    ordemMenu: 71
  },
  {
    path: "/usuarios/:id",
    name: "Usuários",
    icon: "ni ni-tv-2 text-primary",
    component: <FormUsuario />,
    layout: "/admin",
    showMenu: false,
    acoes: ['usuario.gerenciar']
  },
  {
    path: "/perfis",
    name: "Perfis",
    icon: "ni ni-tv-2 text-primary",
    component: <Perfis />,
    layout: "/admin",
    showMenu: true,
    acoes: ['perfil.visualizar'],
    grupo: "Usuários e acessos",
    ordemMenu: 72
  },
  {
    path: "/perfis/:id",
    name: "Perfis",
    icon: "ni ni-tv-2 text-primary",
    component: <FormPerfil />,
    layout: "/admin",
    showMenu: false,
    acoes: ['perfil.visualizar']
  },
  {
    path: "/ordens_servico",
    name: "Ordens de Serviço",
    icon: "ni ni-tv-2 text-primary",
    component: <OrdensServico />,
    layout: "/admin",
    showMenu: true,
    acoes: ['os.visualizar_lista'],
    grupo: "Operação",
    ordemMenu: 21
  },
  {
    path: "/ordens_servico/:id",
    name: "Ordens de Serviço",
    icon: "ni ni-tv-2 text-primary",
    component: <FormOrdemServico />,
    layout: "/admin",
    showMenu: false,
  },
  {
    path: "/relatorios",
    name: "Relatórios",
    icon: "ni ni-tv-2 text-primary",
    component: <Relatorios />,
    layout: "/admin",
    showMenu: true,
    acoes: ['relatorio.gerar'],
    ordemMenu: 60
  },


  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
    showMenu: false,
  },
  {
    path: "/resetar_senha",
    name: "Resetar Senha",
    icon: "ni ni-key-25 text-info",
    component: <ResetarSenha />,
    layout: "/auth",
    showMenu: false,
  },
  // {
  //   path: "/incluir_os_semaforica",
  //   name: "Incluir OS Semafórica",
  //   icon: "ni ni-key-25 text-info",
  //   component: <IncluirOSSemaforica />,
  //   layout: null,
  //   showMenu: false,
  // },

  ...(config.showMenu ? templateRoutes : [])
].sort((a, b) => ordemMenu(a) - ordemMenu(b));
export default routes;

function ordemMenu(item) {
  // ordem fixa do menu (SDD 035): dezena = grupo, unidade = posição dentro dele -- Sidebar.js
  // renderiza cada grupo na posição do primeiro item dele. Rotas fora do menu vão pro fim.
  return item.ordemMenu ?? Number.MAX_SAFE_INTEGER
}
